import Select from 'react-select';
import React, {useRef, useState} from "react";
import {ordersStructure, translateOptions} from "../../../config";
import {useDispatch, useSelector} from "react-redux";
import {timeFrom, timeTo} from "../../../utils/timeInterval";
import DatePicker from "react-datepicker";

// Импорт экшенов под интежеры
import {
    setFiltertxCNTFrom,
    setFiltertxCNTTo,
    setFilterIterBuyFrom,
    setFilterIterBuyTo,
    setFilterIterSellFrom,
    setFilterIterSellTo,
    setFilterTargIdxFrom,
    setFilterTargIdxTo,
    setFilterorderIdFrom,
    setFilterorderIdTo,
    setFilterOrderIdPairedFrom,
    setFilterOrderIdPairedTo,
} from "../../../store/actions/settingsActions";


// Импорт экшенов под флоты
import {
    setFilteramountForOperFrom,
    setFilteramountForOperTo,
    setFilterorderAmountForOperExecFrom,
    setFilterorderAmountForOperExecTo,
    setFilterorderPriceFrom,
    setFilterorderPriceTo,
    setFilterorderOrigAmountFrom,
    setFilterorderOrigAmountTo,
    setFilterorderAmountFrom,
    setFilterorderAmountTo,
    setFilterorderExecFrom,
    setFilterorderExecTo,
    setFilterfeeResultFrom,
    setFilterfeeResultTo,
    setFilterorderRemainsFrom,
    setFilterorderRemainsTo,
} from "../../../store/actions/settingsActions";
import {SET_FILTER_ORDER_ALG, SET_FILTER_SIDE, SET_FILTER_STATUS, SET_FILTER_TYPE} from "../../../store/types";

// Импорт экшенов под селекты
import {
    setFilterSide,
    setFilterStatus,
    setFilterType,
    setFilterOrderAlg,
    setFilterIsRobotOrder,
    setFilterCycleEnd,
    setFilterCycleStage,
    setFilterBaseCurr
} from "../../../store/actions/settingsActions";

// Импорт экшенов под даты
import {
    setFilterSdTimeFrom,
    setFilterSdTimeTo,
    setFilterFdTimeFrom,
    setFilterFdTimeTo
} from "../../../store/actions/settingsActions";

function Filter() {

    // Импорт диспатчера
    const dispatch = useDispatch();

    // Подписка на изменение стейта ордеров и настроек
    const settings = useSelector(state => state.settings);

    let sideValuesSet = useSelector(state => state.orders.sideValuesSet).map(value => {
        return {value: value, label: value};
    });

    let statusValuesSet = useSelector(state => state.orders.statusValuesSet).map(value => {
        return {value: value, label: value};
    });
    let typeValuesSet = useSelector(state => state.orders.typeValuesSet).map(value => {
        return {value: value, label: value};
    });
    let OrderAlgValuesSet = useSelector(state => state.orders.OrderAlgValuesSet).map(value => {
        return {value: value, label: value};
    });


    let isRobotOrderSet = useSelector(state => state.orders.isRobotOrderSet).map(value => {
        return {value: value, label: value};
    });

    let cycleEndSet = useSelector(state => state.orders.cycleEndSet).map(value => {
        return {value: value, label: value};
    });
    let cycleStageSet = useSelector(state => state.orders.cycleStageSet).map(value => {
        return {value: value, label: value};
    });
    let baseCurrSet = useSelector(state => state.orders.baseCurrSet).map(value => {
        return {value: value, label: value};
    });


    sideValuesSet.unshift({value: '', label: translateOptions.selectDefault});
    statusValuesSet.unshift({value: '', label: translateOptions.selectDefault});
    typeValuesSet.unshift({value: '', label: translateOptions.selectDefault});
    OrderAlgValuesSet.unshift({value: '', label: translateOptions.selectDefault});
    isRobotOrderSet.unshift({value: '', label: translateOptions.selectDefault});
    cycleEndSet.unshift({value: '', label: translateOptions.selectDefault});
    cycleStageSet.unshift({value: '', label: translateOptions.selectDefault});
    baseCurrSet.unshift({value: '', label: translateOptions.selectDefault});


    // Локальные стейты и хэндлеры на интежер фильтры
    const [filtertxCNTFromValue, updatefiltertxCNTFromValue] = useState(settings.filtertxCNTFrom);
    const [filtertxCNTToValue, updatefiltertxCNTToValue] = useState(settings.filtertxCNTTo);
    const [filterIterBuyFromValue, updatefilterIterBuyFromValue] = useState(settings.filterIterBuyFrom);
    const [filterIterBuyToValue, updatefilterIterBuyToValue] = useState(settings.filterIterBuyTo);
    const [filterIterSellFromValue, updatefilterIterSellFromValue] = useState(settings.filterIterSellFrom);
    const [filterIterSellToValue, updatefilterIterSellToValue] = useState(settings.filterIterSellTo);
    const [filterTargIdxFromValue, updatefilterTargIdxFromValue] = useState(settings.filterTargIdxFrom);
    const [filterTargIdxToValue, updatefilterTargIdxToValue] = useState(settings.filterTargIdxTo);
    const [filterorderIdFromValue, updatefilterorderIdFromValue] = useState(settings.filterorderIdFrom);
    const [filterorderIdToValue, updatefilterorderIdToValue] = useState(settings.filterorderIdTo);
    const [filterOrderIdPairedFromValue, updatefilterOrderIdPairedFromValue] = useState(settings.filterOrderIdPairedFrom);
    const [filterOrderIdPairedToValue, updatefilterOrderIdPairedToValue] = useState(settings.filterOrderIdPairedTo);


    // Локальные стейты и хэндлеры на флот фильтры
    const [filteramountForOperFromValue, updateFilteramountForOperFromValue] = useState(settings.filteramountForOperFrom);
    const [filteramountForOperToValue, updateFilteramountForOperToValue] = useState(settings.filteramountForOperTo);
    const [filterorderAmountForOperExecFromValue, updateFilterorderAmountForOperExecFromValue] = useState(settings.filterorderAmountForOperExecFrom);
    const [filterorderAmountForOperExecToValue, updateFilterorderAmountForOperExecToValue] = useState(settings.filterorderAmountForOperExecTo);
    const [filterorderPriceFromValue, updateFilterorderPriceFromValue] = useState(settings.filterorderPriceFrom);
    const [filterorderPriceToValue, updateFilterorderPriceToValue] = useState(settings.filterorderPriceTo);
    const [filterorderOrigAmountFromValue, updateFilterorderOrigAmountFromValue] = useState(settings.filterorderOrigAmountFrom);
    const [filterorderOrigAmountToValue, updateFilterorderOrigAmountToValue] = useState(settings.filterorderOrigAmountTo);
    const [filterorderAmountFromValue, updateFilterorderAmountFromValue] = useState(settings.filterorderAmountFrom);
    const [filterorderAmountToValue, updateFilterorderAmountToValue] = useState(settings.filterorderAmountTo);
    const [filterorderExecFromValue, updateFilterorderExecFromValue] = useState(settings.filterorderExecFrom);
    const [filterorderExecToValue, updateFilterorderExecToValue] = useState(settings.filterorderExecTo);
    const [filterfeeResultFromValue, updateFilterfeeResultFromValue] = useState(settings.filterfeeResultFrom);
    const [filterfeeResultToValue, updateFilterfeeResultToValue] = useState(settings.filterfeeResultTo);
    const [filterorderRemainsFromValue, updateFilterorderRemainsFromValue] = useState(settings.filterorderRemainsFrom);
    const [filterorderRemainsToValue, updateFilterorderRemainsToValue] = useState(settings.filterorderRemainsTo);

    // Локальные стейты и хэндлеры на селект фильтры
    const [filterSideValue, updateFilterSide] = useState(settings.filterSide);
    const [filterStatusValue, updateFilterStatus] = useState(settings.filterStatus);
    const [filterTypeValue, updateFilterType] = useState(settings.filterType);
    const [filterOrderAlgValue, updateFilterOrderAlg] = useState(settings.filterOrderAlg);
    const [filterIsRobotOrderValue, updatefilterIsRobotOrder] = useState(settings.filterIsRobotOrder);
    const [filterCycleEndValue, updatefilterCycleEnd] = useState(settings.filterCycleEnd);
    const [filterCycleStageValue, updatefilterCycleStage] = useState(settings.filterCycleStage);
    const [filterBaseCurrValue, updatefilterBaseCurr] = useState(settings.filterBaseCurr);


    // Локальные стейты и хэндлеры на дэйт фильтры
    const [filterSdTimeFromValue, updateFilterSdTimeFromValue] = useState(settings.filterSdTimeFrom);
    const [filterSdTimeToValue, updateFilterSdTimeToValue] = useState(settings.filterSdTimeTo);
    const [filterFdTimeFromValue, updateFilterFdTimeFromValue] = useState(settings.filterFdTimeFrom);
    const [filterFdTimeToValue, updateFilterFdTimeToValue] = useState(settings.filterFdTimeTo);


    const setIntegerValue = string => {
        if (Number.isNaN(parseInt(string))) {
            return '';
        }

        return parseInt(string);
    };

    const setFloatValue = string => {
        let reg = new RegExp(/^-?\d*(\.\d{0,8})?$/);

        if (reg.test(string)) {
            return string;
        }

        return string.substring(0, string.length - 1);
    };

    const setShortFloatValue = string => {
        let reg = new RegExp(/^-?\d*(\.\d{0,2})?$/);

        if (reg.test(string)) {
            return string;
        }

        return string.substring(0, string.length - 1);
    };

    const handlerFilters = () => {
        // Диспатчим в стейт интеджеры

        function dispatchOneValue(f1, v1, f2, v2,) {
            if ((v1 !== '' && v2 !== '') || (v1 === '' && v2 === '')) {
                dispatch(f1(v1));
                dispatch(f2(v2));
            } else {
                if (!v1) {
                    v1 = v2;
                } else {
                    v2 = v1;
                }

                dispatch(f1(v1));
                dispatch(f2(v2));
            }

        }

        dispatchOneValue(setFiltertxCNTFrom, filtertxCNTFromValue, setFiltertxCNTTo, filtertxCNTToValue);
        dispatchOneValue(setFilterIterBuyFrom, filterIterBuyFromValue, setFilterIterBuyTo, filterIterBuyToValue);
        dispatchOneValue(setFilterIterSellFrom, filterIterSellFromValue, setFilterIterSellTo, filterIterSellToValue);
        dispatchOneValue(setFilterTargIdxFrom, filterTargIdxFromValue, setFilterTargIdxTo, filterTargIdxToValue);
        dispatchOneValue(setFilterorderIdFrom, filterorderIdFromValue, setFilterorderIdTo, filterorderIdToValue);
        dispatchOneValue(setFilterOrderIdPairedFrom, filterOrderIdPairedFromValue, setFilterOrderIdPairedTo, filterOrderIdPairedToValue);

        // Диспатчим в стейт флоты
        dispatchOneValue(setFilteramountForOperFrom, filteramountForOperFromValue, setFilteramountForOperTo, filteramountForOperToValue);
        dispatchOneValue(setFilterorderAmountForOperExecFrom, filterorderAmountForOperExecFromValue, setFilterorderAmountForOperExecTo, filterorderAmountForOperExecToValue);
        dispatchOneValue(setFilterorderPriceFrom, filterorderPriceFromValue, setFilterorderPriceTo, filterorderPriceToValue);
        dispatchOneValue(setFilterorderOrigAmountFrom, filterorderOrigAmountFromValue, setFilterorderOrigAmountTo, filterorderOrigAmountToValue);
        dispatchOneValue(setFilterorderAmountFrom, filterorderAmountFromValue, setFilterorderAmountTo, filterorderAmountToValue);
        dispatchOneValue(setFilterorderExecFrom, filterorderExecFromValue, setFilterorderExecTo, filterorderExecToValue);
        dispatchOneValue(setFilterfeeResultFrom, filterfeeResultFromValue, setFilterfeeResultTo, filterfeeResultToValue);
        dispatchOneValue(setFilterorderRemainsFrom, filterorderRemainsFromValue, setFilterorderRemainsTo, filterorderRemainsToValue);

        // Диспатчим в стейт даты
        dispatchOneValue(setFilterSdTimeFrom, filterSdTimeFromValue, setFilterSdTimeTo, filterSdTimeToValue);
        dispatchOneValue(setFilterFdTimeFrom, filterFdTimeFromValue, setFilterFdTimeTo, filterFdTimeToValue);


        // Диспатчим в стейт селекты
        dispatch(setFilterSide(filterSideValue));
        dispatch(setFilterStatus(filterStatusValue));
        dispatch(setFilterType(filterTypeValue));
        dispatch(setFilterOrderAlg(filterOrderAlgValue));
        dispatch(setFilterIsRobotOrder(filterIsRobotOrderValue));
        dispatch(setFilterCycleEnd(filterCycleEndValue));
        dispatch(setFilterCycleStage(filterCycleStageValue));
        dispatch(setFilterBaseCurr(filterBaseCurrValue));
    };

    const clearFilters = () => {
        // Диспатчим в стейт интеджеры
        dispatch(setFiltertxCNTFrom(''));
        dispatch(setFiltertxCNTTo(''));
        dispatch(setFilterIterBuyFrom(''));
        dispatch(setFilterIterBuyTo(''));
        dispatch(setFilterIterSellFrom(''));
        dispatch(setFilterIterSellTo(''));
        dispatch(setFilterTargIdxFrom(''));
        dispatch(setFilterTargIdxTo(''));
        dispatch(setFilterorderIdFrom(''));
        dispatch(setFilterorderIdTo(''));
        dispatch(setFilterOrderIdPairedFrom(''));
        dispatch(setFilterOrderIdPairedTo(''));


        // Диспатчим в стейт флоты
        dispatch(setFilteramountForOperFrom(''));
        dispatch(setFilteramountForOperTo(''));
        dispatch(setFilterorderAmountForOperExecFrom(''));
        dispatch(setFilterorderAmountForOperExecTo(''));
        dispatch(setFilterorderPriceFrom(''));
        dispatch(setFilterorderPriceTo(''));
        dispatch(setFilterorderOrigAmountFrom(''));
        dispatch(setFilterorderOrigAmountTo(''));
        dispatch(setFilterorderAmountFrom(''));
        dispatch(setFilterorderAmountTo(''));
        dispatch(setFilterorderExecFrom(''));
        dispatch(setFilterorderExecTo(''));
        dispatch(setFilterfeeResultFrom(''));
        dispatch(setFilterfeeResultTo(''));
        dispatch(setFilterorderRemainsFrom(''));
        dispatch(setFilterorderRemainsTo(''));

        // Диспатчим в стейт селекты
        dispatch(setFilterSide(''));
        dispatch(setFilterStatus(''));
        dispatch(setFilterType(''));
        dispatch(setFilterOrderAlg(''));
        dispatch(setFilterIsRobotOrder(''));
        dispatch(setFilterCycleEnd(''));
        dispatch(setFilterCycleStage(''));
        dispatch(setFilterBaseCurr(''));

        // Диспатчим в стейт даты
        dispatch(setFilterSdTimeFrom(''));
        dispatch(setFilterSdTimeTo(''));
        dispatch(setFilterFdTimeFrom(''));
        dispatch(setFilterFdTimeTo(''));
    };

    return (
        <div className={'orders-settings__filters-group'}>

            {/*filterSide*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.side.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.side.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={sideValuesSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterSideValue, label: filterSideValue}}
                        onChange={event => {
                            updateFilterSide(event.value);
                        }}
                    />
                </div>
            </div>

            {/*filterIsRobotOrder*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div
                        className={'orders-settings__filters-group-title-big'}>{ordersStructure.isRobotOrder.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.isRobotOrder.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={isRobotOrderSet}
                        classNamePrefix={'react-select'}
                        value={{
                            value: filterIsRobotOrderValue, label: filterIsRobotOrderValue
                        }}
                        onChange={event => {
                            updatefilterIsRobotOrder(event.value);
                        }}
                    />
                </div>
            </div>

            {/*filterCycleEnd*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.cycleEnd.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.cycleEnd.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={cycleEndSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterCycleEndValue, label: filterCycleEndValue}}
                        onChange={event => {
                            updatefilterCycleEnd(event.value);
                        }}
                    />
                </div>
            </div>

            {/*filterCycleStage*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.cycleStage.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.cycleStage.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={cycleStageSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterCycleStageValue, label: filterCycleStageValue}}
                        onChange={event => {
                            updatefilterCycleStage(event.value);
                        }}
                    />
                </div>
            </div>

            {/*filterBaseCurr*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.baseCurr.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.baseCurr.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={baseCurrSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterBaseCurrValue, label: filterBaseCurrValue}}
                        onChange={event => {
                            updatefilterBaseCurr(event.value);
                        }}
                    />
                </div>
            </div>


            {/*orderId*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderId.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderId.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderIdFromValue} placeholder={translateOptions.from} onChange={event => {
                        updatefilterorderIdFromValue(setIntegerValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderIdToValue} placeholder={translateOptions.to} onChange={event => {
                        updatefilterorderIdToValue(setIntegerValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*status*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.status.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.status.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={statusValuesSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterStatusValue, label: filterStatusValue}}
                        onChange={event => {
                            updateFilterStatus(event.value);
                        }}
                    />
                </div>
            </div>

            {/*type*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.type.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.type.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={typeValuesSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterTypeValue, label: filterTypeValue}}
                        onChange={event => {
                            updateFilterType(event.value);
                        }}
                    />
                </div>
            </div>

            {/*SdTime*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.sdTime.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.sdTime.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-date-interval custom-datepicker'}>
                    <div className={'orders-settings__filters-group-item-date-interval-item'}>
                        <DatePicker
                            selected={filterSdTimeFromValue}
                            onChange={date => updateFilterSdTimeFromValue(date)}
                            className="custom-datepicker__input"
                            locale={window.locale}
                            dateFormat="dd.MM.yyyy"
                            minDate={timeFrom}
                            maxDate={timeTo}
                        />
                    </div>
                    <div className={'orders-settings__filters-group-item-date-interval-item'}>
                        <DatePicker
                            selected={filterSdTimeToValue}
                            onChange={date => updateFilterSdTimeToValue(date)}
                            className="custom-datepicker__input"
                            locale={window.locale}
                            dateFormat="dd.MM.yyyy"
                            minDate={timeFrom}
                            maxDate={timeTo}
                        />
                    </div>
                </div>
            </div>

            {/*FdTime*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.fdTime.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.fdTime.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-date-interval custom-datepicker'}>
                    <div className={'orders-settings__filters-group-item-date-interval-item'}>
                        <DatePicker
                            selected={filterFdTimeFromValue}
                            onChange={date => updateFilterFdTimeFromValue(date)}
                            className="custom-datepicker__input"
                            locale={window.locale}
                            dateFormat="dd.MM.yyyy"
                            minDate={timeFrom}
                            maxDate={timeTo}
                        />
                    </div>
                    <div className={'orders-settings__filters-group-item-date-interval-item'}>
                        <DatePicker
                            selected={filterFdTimeToValue}
                            onChange={date => updateFilterFdTimeToValue(date)}
                            className="custom-datepicker__input"
                            locale={window.locale}
                            dateFormat="dd.MM.yyyy"
                            minDate={timeFrom}
                            maxDate={timeTo}
                        />
                    </div>
                </div>
            </div>

            {/*orderPrice*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderPrice.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderPrice.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderPriceFromValue} placeholder={translateOptions.from} onChange={event => {
                        updateFilterorderPriceFromValue(setShortFloatValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderPriceToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilterorderPriceToValue(setShortFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*orderOrigAmount*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div
                        className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderOrigAmount.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderOrigAmount.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderOrigAmountFromValue} placeholder={translateOptions.from}
                           onChange={event => {
                               updateFilterorderOrigAmountFromValue(setFloatValue(event.target.value));
                           }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderOrigAmountToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilterorderOrigAmountToValue(setFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*amountForOper*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div
                        className={'orders-settings__filters-group-title-big'}>{ordersStructure.amountForOper.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.amountForOper.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filteramountForOperFromValue} placeholder={translateOptions.from} onChange={event => {
                        updateFilteramountForOperFromValue(setFloatValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filteramountForOperToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilteramountForOperToValue(setFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*orderAmountForOperExec*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div
                        className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderAmountForOperExec.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderAmountForOperExec.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderAmountForOperExecFromValue} placeholder={translateOptions.from}
                           onChange={event => {
                               updateFilterorderAmountForOperExecFromValue(setFloatValue(event.target.value));
                           }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderAmountForOperExecToValue} placeholder={translateOptions.to}
                           onChange={event => {
                               updateFilterorderAmountForOperExecToValue(setFloatValue(event.target.value));
                           }}/>
                </div>
            </div>

            {/*orderAmount*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderAmount.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderAmount.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderAmountFromValue} placeholder={translateOptions.from} onChange={event => {
                        updateFilterorderAmountFromValue(setFloatValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderAmountToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilterorderAmountToValue(setFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*orderExec*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderExec.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderExec.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderExecFromValue} placeholder={translateOptions.from} onChange={event => {
                        updateFilterorderExecFromValue(setFloatValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderExecToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilterorderExecToValue(setFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*feeResult*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.feeResult.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.feeResult.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterfeeResultFromValue} placeholder={translateOptions.from} onChange={event => {
                        updateFilterfeeResultFromValue(setFloatValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterfeeResultToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilterfeeResultToValue(setFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*txCNT*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.txCNT.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.txCNT.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filtertxCNTFromValue} placeholder={translateOptions.from} onChange={event => {
                        updatefiltertxCNTFromValue(setIntegerValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filtertxCNTToValue} placeholder={translateOptions.to} onChange={event => {
                        updatefiltertxCNTToValue(setIntegerValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*OrderIdPaired*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div
                        className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderIdPaired.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderIdPaired.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterOrderIdPairedFromValue} placeholder={translateOptions.from} onChange={event => {
                        updatefilterOrderIdPairedFromValue(setIntegerValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterOrderIdPairedToValue} placeholder={translateOptions.to} onChange={event => {
                        updatefilterOrderIdPairedToValue(setIntegerValue(event.target.value));
                    }}/>
                </div>
            </div>


            {/*orderRemains*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div
                        className={'orders-settings__filters-group-title-big'}>{ordersStructure.orderRemains.name}</div>
                    <div
                        className={'orders-settings__filters-group-title-small'}>{ordersStructure.orderRemains.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderRemainsFromValue} placeholder={translateOptions.from} onChange={event => {
                        updateFilterorderRemainsFromValue(setFloatValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterorderRemainsToValue} placeholder={translateOptions.to} onChange={event => {
                        updateFilterorderRemainsToValue(setFloatValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*TargIdx*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.TargIdx.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.TargIdx.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterTargIdxFromValue} placeholder={translateOptions.from} onChange={event => {
                        updatefilterTargIdxFromValue(setIntegerValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterTargIdxToValue} placeholder={translateOptions.to} onChange={event => {
                        updatefilterTargIdxToValue(setIntegerValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*OrderAlg*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.OrderAlg.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.OrderAlg.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-select'}>
                    <Select
                        options={OrderAlgValuesSet}
                        classNamePrefix={'react-select'}
                        value={{value: filterOrderAlgValue, label: filterOrderAlgValue}}
                        onChange={event => {
                            updateFilterOrderAlg(event.value);
                        }}
                    />
                </div>
            </div>

            {/*IterBuy*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.IterBuy.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.IterBuy.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterIterBuyFromValue} placeholder={translateOptions.from} onChange={event => {
                        updatefilterIterBuyFromValue(setIntegerValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterIterBuyToValue} placeholder={translateOptions.to} onChange={event => {
                        updatefilterIterBuyToValue(setIntegerValue(event.target.value));
                    }}/>
                </div>
            </div>

            {/*IterSell*/}
            <div className={'orders-settings__filters-group-item'}>
                <div className={'orders-settings__filters-group-title'}>
                    <div className={'orders-settings__filters-group-title-big'}>{ordersStructure.IterSell.name}</div>
                    <div className={'orders-settings__filters-group-title-small'}>{ordersStructure.IterSell.desc}</div>
                </div>
                <div className={'orders-settings__filters-group-item-integer'}>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterIterSellFromValue} placeholder={translateOptions.from} onChange={event => {
                        updatefilterIterSellFromValue(setIntegerValue(event.target.value));
                    }}/>
                    <input className={'orders-settings__filters-group-item-input input__text'}
                           value={filterIterSellToValue} placeholder={translateOptions.to} onChange={event => {
                        updatefilterIterSellToValue(setIntegerValue(event.target.value));
                    }}/>
                </div>
            </div>


            <div className={'orders-settings__filters-group-button'}>
                <div className={'orders-settings__filters-group-button-item button button--input-row'}
                     onClick={clearFilters}>{translateOptions.filterClearButton}</div>
            </div>

            <div className={'orders-settings__filters-group-button'}>
                <div className={'orders-settings__filters-group-button-item button button--input-row'}
                     onClick={handlerFilters}>{translateOptions.filterSearchButton}</div>
            </div>
        </div>
    );
}

export default Filter;
